// import monitorQueryList from '../components/monitorQuery/monitorQueryList.vue'

export default [
    { 
        path: 'monitorQuery/monitorQueryList', 
        component: resolve => require(['@/components/monitorQuery/monitorQueryList'],resolve),
        name:'monitorQueryList',
        meta:{
            id:'850',
            node:'monitorQuery',
            url:'monitorQueryList',
        }
    },
]


// WEBPACK FOOTER //
// ./src/router/monitorQuery.js